import { render } from "./NewTag.vue?vue&type=template&id=286359d6&ts=true"
import script from "./NewTag.ts?vue&type=script&lang=ts&external"
export * from "./NewTag.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__